import React from 'react';
import { EventCard as EventCardBase } from '@morressier/ts';
import { IEventSearchResult } from '../../../typings/event';

type IEventCardProps = IEventSearchResult;

const EventCard: React.FC<IEventCardProps> = ({
  bannerUrl,
  name,
  startDate,
  endDate,
  embargoed,
  organizationName,
  highlightResult,
  location
}) => {
  return (
    <EventCardBase
      bannerUrl={bannerUrl}
      name={name}
      startDate={startDate}
      endDate={endDate}
      embargoed={embargoed}
      organizationName={organizationName}
      nameHighlightingInformation={highlightResult.name}
      organizationNameHighlightingInformation={highlightResult.organizationName}
      location={location}
    />
  );
};

export default EventCard;
